module.exports = "/confirm_mail-6527d0bfe139113340e35df918f0d956.svg";